import Interceptor from "./Interceptor";

export const registerUser = async (payload) => {
  try {
    const response = await Interceptor.post("/auth/register", payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const loginUser = async (payload) => {
  try {
    const response = await Interceptor.post("/auth/login", payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getLoggedInUser = async (payload) => {
  try {
    const response = await Interceptor.get("/auth/me");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateUser = async (payload) => {
  try {
    // payload = { firstName, lastName, email }
    const response = await Interceptor.put("/auth/update-profile", payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const changePassword = async (payload) => {
  try {
    const response = await Interceptor.post("/auth/change-password", payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const verifyEmail = async (token) => {
  try {
    const response = await Interceptor.get(
      `/auth/verify-email?token=${encodeURIComponent(token)}`,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const resendVerificationEmail = async () => {
  try {
    const response = await Interceptor.post("/auth/resend-verification");
    return response.data;
  } catch (error) {
    throw error;
  }
};

// export const getAuthKitUser = async () => {
//   try {
//     const response = await Interceptor.get(`/auth/user`);
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
//   // return null;
// };

// export const resetUserPassword = async (payload) => {
//   try {
//     const response = await Interceptor.post(`/auth/reset-password`, payload);
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
//   // return null;
// };
